export const MAIN_PATHS = {
  main: '/main',
};
